<template>
  <div>
    <div class="form">
      <h1 class="title">Register</h1>
      <div class="tile is-vertical is-4">
        <b-field label="Email">
          <b-input icon="email" type="email" v-model="email" />
        </b-field>
        <b-field label="Password">
          <b-input type="password" icon="lock" password-reveal v-model="password" />
        </b-field>
        <b-message type="is-danger" v-if="error">{{ error }}</b-message>
        <b-button @click='onSubmit' type='is-success' :loading='loading' label='BECOME A MEMBER'></b-button>
      </div>
    </div>
    <v-row justify="center">
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <br />
          <v-card class="verify">
            <br />
            <div class="link">
              A verification link has been sent to your email. please click on the link in your
              <a
                href="https://mail.google.com"
                target="_self"
              >email</a> to continue.
              <br />
              <strong>Thank you for choosing Natural Home of remedies</strong>
            </div>
          </v-card>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: 'register',
  computed: {
    ...mapGetters(["isLoggedIn"]),
    nextRoute() {
      return this.$route.query.redirect || "/";
    }
  },
  data() {
    return {
      email: "",
      password: "",
      isLoading: false,
      loading: false,
      dialog: false,
      error: "",
      Name:'',
      Tel: '',
    };
  },
  // // watch: {
  // //   isLoggedIn: function(changedUser) {
  // //     if (changedUser) {
  // //       this.$router.replace(this.nextRoute);
  // //     }
  // //   }
  // },
  methods: {
    ...mapActions(["clearMessage", "addMessage", "registerByEmail"]),
    onSubmit() {
      this.loading = true;
      let data = {
        email: this.email,
        password: this.password
      };
        this.registerByEmail(data)
        .then(() => {
          const user = this.$fb.auth.currentUser;
          const actionCodeSettings = {
            url: `${(process.env.VUE_APP_HOST_NAME =
              "https://natural-home-of-remedies.web.app")}/sign-in/?email=${
                user.email
            }`
          };
          user.sendEmailVerification(actionCodeSettings);
          this.dialog = true;
          setTimeout(() => {
            this.$router.push('/data')
          })
        })
        .catch(error => {
          this.loading = false;
          this.error = error.message;
        })
        .then(() => {
          // this.$fb.database.collection('user').add({
          //   name: this.Name,
          //   phone: this.Tel,
          //   email: this.email
          // })
        });
        }
    }
};
const app = document.createElement("div");
app.setAttribute("data-app", true);
document.body.append(app);
</script>

<style>
.link {
  width: 50%;
  margin: auto;
}
.signincard {
  margin: auto;
}
.verify {
  width: 50%;
  margin: auto;
  height: 400px;
}
</style>
